import { Timestamp } from "firebase/firestore";


export enum FeedbakType {
  issue = "issue",
  suggestion = "suggestion",
}

export interface SKFeedback {
    id?: string;
    feedbackDate?: Timestamp;
    type?: string;
    category?: string;
    appVersion?: string;
    userID?: string
    phone?: string;
    osType?: string;
    osVersion?: string;
    message?: string;
}



